import React from "react";
import AsyncAutoCompleteContained from "../../AsyncAutoCompleteContained";
import { AutoCompleteProps } from "../../../Types/AutoComplete/AutoCompleteProps";
import { useTranslation } from "react-i18next";

const ItemAutoComplete: React.FC<AutoCompleteProps> = ({ onChange, valueId, label, load = true, disabled = false, infoText, error, helperText, onKeyDown }) => {

    const { t } = useTranslation();

    return (
        <AsyncAutoCompleteContained
            label={label ?? t("common.item")}
            url="/autocompleteApi/GetItems"
            valueId={valueId}
            load={load}
            onChange={onChange}
            infoText={infoText}
            error={error}
            helperText={helperText}
            disabled={disabled}
            onKeyDown={onKeyDown}
        />
    );
};

export default ItemAutoComplete;
